<div *ngFor="let item of resumenes" class="m-b">
  <app-card-seguro-privado
    [resumen]="item"
    class="card"
  ></app-card-seguro-privado>
</div>
